import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private digitalAssetSubject = new BehaviorSubject<string>('');
  public digitalAsset$ = this.digitalAssetSubject.asObservable();
  
  private sessionLoadedSubject = new BehaviorSubject<boolean>(false);
  public sessionLoaded$ = this.sessionLoadedSubject.asObservable();

  constructor() {
    // Initial load
    this.loadSessionData();
    
    // Set up listener for storage changes
    window.addEventListener('storage', () => this.loadSessionData());
  }

  public loadSessionData(): void {
    try {
      const sessionData = localStorage.getItem('ferrerSessionData');
      if (sessionData) {
        const parsedData = JSON.parse(sessionData);
        if (parsedData && parsedData.digitalAsset) {
          this.digitalAssetSubject.next(parsedData.digitalAsset);
        }
      }
      this.sessionLoadedSubject.next(true);
    } catch (error) {
      this.sessionLoadedSubject.next(true); // Mark as loaded even on error
    }
  }

  public getDigitalAsset(): string {
    return this.digitalAssetSubject.value;
  }
  
  public updateDigitalAsset(value: string): void {
    this.digitalAssetSubject.next(value);
  }
}